module.exports = __webpack_public_path__ + "media/images/landkit/devices/iphonex-174cf24fbb552049b4dc4ecab4005bac.png";